export default {
  auth: () => import("/opt/buildhome/repo/layouts/auth.vue"),
  default: () => import("/opt/buildhome/repo/layouts/default.vue")
}